module.exports = __webpack_public_path__ + "static/media/add_card.dbf7fe6f.svg";